import React from 'react';
import { Col, Row, Typography } from 'antd';
import currencyFormat from 'utils/currencyFormat';
import PropTypes from 'prop-types';
import { DASHBOARD_SUMMARY_TEXT } from 'constants/dashboard';
import './DashBoardSummaryCard.scss';
import { TransactionCardIcon1, TransactionCardIcon2 } from 'utils/icons';

function DashboardTransactionSummaryCard({ dashBoardSummary }) {
  return (
    <div>
      <Row gutter={[16, 16]} className="dashBoard-summary">
        <Col xs={24} sm={12} md={12} lg={6}>
          <div className="dashBoard-summary-card">
            <div className="dashBoard-summary-card-row">
              <div className="dashBoard-summary-card-color">
                <div className="dashBoard-summary-card-color-image">
                  <TransactionCardIcon1 style={{ fontSize: '2rem' }} />
                </div>
              </div>
              <div className="dashBoard-summary-text">
                <Typography.Text className="responsive-font">
                  {DASHBOARD_SUMMARY_TEXT?.total_transaction_amount}
                </Typography.Text>
                <Typography.Text style={{ fontWeight: 'normal' }} className="responsive-font">
                  {currencyFormat(dashBoardSummary?.total_transaction_amount ?? 0, true, true)}
                </Typography.Text>
              </div>
            </div>
          </div>
        </Col>

        <Col xs={24} sm={12} md={12} lg={6}>
          <div className="dashBoard-summary-card">
            <div className="dashBoard-summary-card-row">
              <div className="dashBoard-summary-card-color">
                <div className="dashBoard-summary-card-color-image">
                  <TransactionCardIcon1 style={{ fontSize: '2rem' }} />
                </div>
              </div>
              <div className="dashBoard-summary-text">
                <Typography.Text className="responsive-font">
                  {DASHBOARD_SUMMARY_TEXT?.total_transaction_count}
                </Typography.Text>
                <Typography.Text style={{ fontWeight: 'normal' }} className="responsive-font">
                  {dashBoardSummary?.total_transaction_count}
                </Typography.Text>
              </div>
            </div>
          </div>
        </Col>

        <Col xs={24} sm={12} md={12} lg={6}>
          <div className="dashBoard-summary-card">
            <div className="dashBoard-summary-card-row">
              <div className="dashBoard-summary-card-color">
                <div className="dashBoard-summary-card-color-image">
                  <TransactionCardIcon2 style={{ fontSize: '2rem' }} />
                </div>
              </div>
              <div className="dashBoard-summary-text">
                <Typography.Text className="responsive-font">
                  {DASHBOARD_SUMMARY_TEXT?.success_count}
                </Typography.Text>
                <Typography.Text style={{ fontWeight: 'normal' }} className="responsive-font">
                  {dashBoardSummary?.success_count}
                </Typography.Text>
              </div>
            </div>
          </div>
        </Col>

        <Col xs={24} sm={12} md={12} lg={6}>
          <div className="dashBoard-summary-card">
            <div className="dashBoard-summary-card-row">
              <div className="dashBoard-summary-card-color">
                <div className="dashBoard-summary-card-color-image">
                  <TransactionCardIcon2 style={{ fontSize: '2rem' }} />
                </div>
              </div>
              <div className="dashBoard-summary-text">
                <Typography.Text className="responsive-font">
                  {DASHBOARD_SUMMARY_TEXT?.success_rate}
                </Typography.Text>
                <Typography.Text className="responsive-font">
                  {dashBoardSummary?.success_rate ?? 0}%
                </Typography.Text>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

DashboardTransactionSummaryCard.propTypes = {
  dashBoardSummary: PropTypes.instanceOf(Object).isRequired
};

export default DashboardTransactionSummaryCard;
